// How many units a claim line is worth.
//
// `claim_lines.units` is the SV104 value on the 837P and the Units column on
// the GAMMIS CSV. GAMMIS bills S9123 and S9122 in 15-minute units — remittance
// 13512807 carries 25 units on a single day, which cannot be hours — and the
// 837P companion guide is explicit that SV104 takes whole numbers only.
//
// This is one line of arithmetic living in its own module because it is
// applied in four places across two runtimes: the billing wizard, the resync
// path, the weekly edge function, and anything that builds a line later. The
// last rule that was written out four times was prior-authorisation
// resolution, the copies drifted, and a guard bug reached production.
//
// Deliberately runtime-neutral — no imports — so the edge function can reach
// it through supabase/functions/_shared/lib.

/** Fifteen-minute units per hour. */
export const UNITS_PER_HOUR = 4;

/**
 * Whole 15-minute units for a number of hours.
 *
 * Rounds to the nearest unit rather than truncating: a 5.8-hour visit is
 * closer to 23 units (5.75h) than to 23.2, and 23.2 is not a quantity any
 * claim can carry. Non-positive or unusable input is zero units, which the
 * pre-flight check then blocks rather than filing.
 */
export const unitsFromHours = (hours) => {
  const h = Number(hours);
  if (!Number.isFinite(h) || h <= 0) return 0;
  return Math.round(h * UNITS_PER_HOUR);
};
